module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/4-default-deny-all.svg";